module.exports = __webpack_public_path__ + "img/month_3_icon.d55b5fab.png";